import { render, staticRenderFns } from "./PanelColorSelector.vue?vue&type=template&id=1151e486&scoped=true&"
import script from "./PanelColorSelector.vue?vue&type=script&lang=js&"
export * from "./PanelColorSelector.vue?vue&type=script&lang=js&"
import style0 from "./PanelColorSelector.vue?vue&type=style&index=0&id=1151e486&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151e486",
  null
  
)

export default component.exports